import { graphql } from "@/gql";

export const updateClientTrackingStatusMutation = graphql(`
  mutation UpdateClientTrackingStatus($input: UpdateTrackingStatusInput!) {
    updateTrackingStatus(input: $input) {
      client {
        id
        trackingStatus
      }
    }
  }
`);

export const createEventRemarkMutation = graphql(`
  mutation CreateEventRemark($input: CreateEventRemarkInput!, $clientId: ID!) {
    createEventRemark(input: $input) {
      event {
        ...TimelineEntry
      }
      query {
        client(id: $clientId) {
          id
          lastEvent {
            ...TimelineEntry
          }
          events(order: DESC) {
            nodes {
              ...TimelineEntry
            }
          }
        }
      }
    }
  }
`);
